'use client'

import { css, cx } from '@lastbrand/web-ui-styled-system/css'

import LoaderSVG from '@src/quince-components/src/atoms/loaderWrapper/LoaderSVG'

import type { LoaderWrapperDSProps } from './loader-wrapper-ds.types'

// eslint-disable-next-line i18next/no-literal-string -- Panda spacing tokens (not user-facing copy)
const loaderWrapperClass = css({
  position: 'relative',
  my: 'space-100',
  mx: 'auto',
  alignItems: 'center',
  justifyContent: 'center',
})

export function LoaderWrapperDS({
  testid,
  showLoader,
  // eslint-disable-next-line i18next/no-literal-string -- CSS length value (not user-facing copy)
  minHeight = '31rem',
  children,
  loadWrapperClassName,
  containerClassName,
  childrenClassName,
  // eslint-disable-next-line i18next/no-literal-string -- CSS length value (not user-facing copy)
  loaderSize = '4rem',
}: LoaderWrapperDSProps) {
  return (
    <div data-testid={testid} className={cx(containerClassName)}>
      <div
        style={{ display: showLoader ? 'flex' : 'none', minHeight }}
        className={cx(loaderWrapperClass, loadWrapperClassName)}
      >
        <LoaderSVG size={loaderSize} />
      </div>
      <div className={cx(childrenClassName)} style={showLoader ? { display: 'none' } : undefined}>
        {children}
      </div>
    </div>
  )
}
